const Loader = () => (
	<div className="flex justify-center items-center py-3">
		<div className="animate-spin rounded-full h-24 w-24 border-b-4 border-light-blue-500 border-opacity-50 " />
	</div>
);

export default Loader;
